import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Subtract = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Subtract' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,12 L22,12' />
  </StyledIcon>
);
